(function ($) {
	$(document).ready(function () {
		/* This will be reused to show only the selected category, if a category is selected */

		function areThereResults() {
			const results = $("#successStoryResults");
			let resultsHeight = results.height();
			const noResultMessage = $("#noResults");
			if (resultsHeight < 75) {
				noResultMessage.show();
			} else {
				noResultMessage.hide();
			}
		}
		areThereResults();
		function filterByCategory(categoryValue, stateValue) {
			$(".success-story-wrapper").each(function (index) {
				$(this).hide();
			});

			function showSelectedPosts(categoryTarget) {
				$(categoryTarget).each(function (index) {
					$(this).show();
				});
			}

			let categoryTarget = "." + categoryValue + "." + stateValue;

			if (categoryValue && stateValue) {
				showSelectedPosts(categoryTarget);
			} else if (categoryValue) {
				let categoryTarget = "." + categoryValue;
				showSelectedPosts(categoryTarget);
			} else if (stateValue) {
				let categoryTarget = "." + stateValue;
				showSelectedPosts(categoryTarget);
			}

			areThereResults();
		}

		/* Get the URL Parameter */
		function getURLParameter(sParam) {
			var sPageURL = window.location.search.substring(1);
			var sURLVariables = sPageURL.split("&");
			for (var i = 0; i < sURLVariables.length; i++) {
				var sParameterName = sURLVariables[i].split("=");
				if (sParameterName[0] == sParam) {
					return sParameterName[1];
				}
			}
		}

		let categoryValue = getURLParameter("category");
		let stateValue = getURLParameter("state");

		/* If there is a category selected (in the URL) then filter the list */
		if (categoryValue && stateValue) {
			filterByCategory(categoryValue, stateValue);
			$("#category").val(categoryValue).change();
			$("#state").val(stateValue).change();
			areThereResults();
		} else if (categoryValue) {
			filterByCategory(categoryValue);
			$("#category").val(categoryValue).change();
			areThereResults();
		} else if (stateValue) {
			filterByCategory(stateValue);
			$("#state").val(stateValue).change();
			areThereResults();
		}

		/* the dropdown for the categories */
		const categorySelect = $("#category");
		const stateSelect = $("#state");

		/* On change of the select option, filter the list*/
		categorySelect.change(function () {
			let categoryValue = $(this).val();
			let stateValue = stateSelect.val();
			filterByCategory(categoryValue, stateValue);

			if (stateValue) {
				window.history.pushState(
					categoryValue + stateValue,
					categoryValue + stateValue,
					"?category=" + categoryValue + "&state=" + stateValue
				);
			} else {
				window.history.pushState(
					categoryValue,
					categoryValue,
					"?category=" + categoryValue
				);
			}
		});

		/* On change of the select option, filter the list*/
		stateSelect.change(function () {
			let stateValue = $(this).val();
			let categoryValue = categorySelect.val();
			filterByCategory(categoryValue, stateValue);

			if (categoryValue) {
				window.history.pushState(
					categoryValue + stateValue,
					categoryValue + stateValue,
					"?category=" + categoryValue + "&state=" + stateValue
				);
			} else {
				window.history.pushState(
					stateValue,
					stateValue,
					"?state=" + stateValue
				);
			}
		});
	});
})(jQuery);
